import React, {useState} from 'react';
import {communicationPref, dualAuth, promotions} from '../../settings';
import LabelAndInput from './LabelAndInput';
import {Tooltip as ReactTooltip} from 'react-tooltip';

function AuthComPromInterface({localeText, communicationPreference = 0}) {
  const [emailOrMail, setEmailOrMail] = useState(communicationPreference);

  function AuthComProm() {
    return (
      <React.Fragment>
        {communicationPref && (
          <LabelAndInput
            name='communication'
            label={localeText(
              'rw_register_title_communication', //TODO add to phrase data
              'Preferred method of communication'
            )}
            type='radio'
            radiooptions={[
              {label: 'email', value: 0, checked: emailOrMail == '0'},
              {label: 'mail', value: 1, checked: emailOrMail == '1'}
            ]}
            onChange={e => setEmailOrMail(e.target.value)}
            className='py-4'
            input_testid='register_input_communication'
            label_testid='register_label_communication'
          />
        )}
        {dualAuth && (
          <div className='mt-4'>
            <input
              name='dual_auth'
              title='dual_auth'
              type='checkbox'
              id='dual_auth'
              data-testid='register_input_dual_auth'
            />
            <label
              htmlFor='dual_auth'
              className='ml-4'
              data-testid='register_label_dual_auth'
            >
              {localeText(
                'rw_register_dual_auth', //TODO add to phrase data
                'Enable Dual Factor Authentication'
              )}

              <i
                className='fa-solid fa-circle-question ml-2'
                data-tooltip-id='my-tooltip-1'
              ></i>
              <ReactTooltip
                id='my-tooltip-1'
                place='bottom'
                content={localeText(
                  'rw_register_dual_auth_tool_tip',
                  'Verification link will be sent each time you log in'
                )}
              />
            </label>
          </div>
        )}
        {promotions && (
          <div className='mt-4'>
            <input
              name='receive_promotions'
              title='receive_promotions'
              type='checkbox'
              id='receive_promotions'
              data-testid='register_input_receive_promotions'
            />
            <label
              htmlFor='receive_promotions'
              className='ml-4'
              data-testid='register_label_receive_promotions'
            >
              {localeText(
                'rw_register_receive_promotions', //TODO add to phrase data
                'I would like to receive promotions and other information'
              )}
            </label>
          </div>
        )}
      </React.Fragment>
    );
  }

  return {emailOrMail, AuthComProm};
}

export default AuthComPromInterface;
